var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import { Col, Row, Select } from "@folio/stripes/components";
import { Controller } from "react-hook-form";
import { useIntl } from "react-intl";
import { AccordionSection } from "../../../AccordionSection";
import { FormatEnum } from "../../../../types/Api";
export var ExportSection = function (_a) {
    var control = _a.control, open = _a.open, onToggle = _a.onToggle;
    var formatMessage = useIntl().formatMessage;
    return (React.createElement(AccordionSection, { id: "progress-report-export", labelId: "ui-br-agency.outputs.progress-report.section.export", open: open, onToggle: onToggle },
        React.createElement(Row, null,
            React.createElement(Col, { xs: 4 },
                React.createElement(Controller, { control: control, name: "format", render: function (_a) {
                        var field = _a.field;
                        return (React.createElement(Select, __assign({}, field, { label: formatMessage({
                                id: "ui-br-agency.outputs.progress-report.field.format",
                            }) }),
                            React.createElement("option", { value: FormatEnum.PDF }, formatMessage({
                                id: "ui-br-agency.outputs.progress-report.format.pdf",
                            })),
                            React.createElement("option", { value: FormatEnum.DOCX }, formatMessage({
                                id: "ui-br-agency.outputs.progress-report.format.docx",
                            })),
                            React.createElement("option", { value: FormatEnum.XLSX }, formatMessage({
                                id: "ui-br-agency.outputs.progress-report.format.xlsx",
                            }))));
                    } })))));
};
